export default {
  namespaced: true,
  state     : {
    rating_common_employees: {
      content: {
        search    : '',
        pagination: {
          sortBy     : 'id',
          rowsPerPage: 10,
          page       : 1,
        },
        headers: [
          {text: 'Курс', value: 'name'},
          {text: 'Дата постановки', value: 'statement_date'},
          {text: 'Статус ', value: 'status'},
          {text: 'Пройдено ', value: 'completed_percent'},
          {text: 'Ср. балл', value: 'average_users_points'},
          // {
          //   text       : 'Результаты теста',
          //   value      : '',
          //   inner_items: [
          //     {
          //       text : 'Выше порога',
          //       value: 'test_passed',
          //     },
          //     {
          //       text : 'Ниже порога',
          //       value: 'test_not_passed',
          //     },
          //     {
          //       text : 'Ср. балл',
          //       value: 'test_average',
          //     },
          //   ],
          // },
          {text: 'Времени затрачено ', value: 'average_users_time'},
        ],
        body: [],
      },
    },
    current_common_employee_rating: null,
  },
  getters: {
    rating_common_employees       : ({rating_common_employees}) => rating_common_employees,
    current_common_employee_rating: ({current_common_employee_rating}) => current_common_employee_rating,
  },
  mutations: {
    SET_PAGINATION(state, value) {
      state.rating_common_employees.content.pagination = {
        ...state.rating_common_employees.content.pagination,
        ...value,
      };
    },
    SET_EMPLOYEES(state, value) {
      state.rating_common_employees.content.body = value;
    },
    SET_CURRENT_COMMON_EMPLOYEE_RATING(state, user) {
      state.current_common_employee_rating = user;
    },
    SET_COMMON_EMPLOYEES_PAGE(state, value) {
      let table = state.rating_common_employees.content;
      table.pagination.page = value;
    },
    SHOW_COMMON_EMPLOYEES_NUMBER(state, selected) {
      let table = state.rating_common_employees.content;

      if (selected == 'Показывать по 10') {
        table.pagination.rowsPerPage = 10;
      } else if (selected == 'Показывать по 25') {
        table.pagination.rowsPerPage = 25;
      } else if (selected == 'Показывать по 50') {
        table.pagination.rowsPerPage = 50;
      } else if (selected == 'Показывать по 100') {
        table.pagination.rowsPerPage = 100;
      }
    },
  },
  actions: {
    async change_common_employees_per_page({commit}, event) {
      commit('SHOW_COMMON_EMPLOYEES_NUMBER', event);
      commit('SET_COMMON_EMPLOYEES_PAGE', 1);
    },
  },
};
